const formatTrialEnd = (dateString) => {
  const yyyymmdd = dateString?.split("T")[0];
  return yyyymmdd;
};

const getDaysBetween = (startDate, endDate) => {
  const toEST = (date) => new Date(new Date(date).toLocaleString("en-US", { timeZone: "America/New_York" }));

  const start = toEST(startDate);
  const end = toEST(`${endDate}T00:00:00`);

  return Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;
};

const getRelativeDate = (date) => {
  if (!date) return "";

  const now = new Date();
  const then = new Date(date);

  const diff = now.getTime() - then.getTime();

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return `${days} days ago`;
  }
  if (hours > 0) {
    return `${hours} hours ago`;
  }
  if (minutes > 0) {
    return `${minutes} minutes ago`;
  }
  return "Just now";
};

const getRelativeLoginDateForUser = (user) => {
  if (user.app_last_open && user.dashboard_last_open) {
    if (user.app_last_open > user.dashboard_last_open) {
      return getRelativeDate(user.app_last_open);
    }
    return getRelativeDate(user.dashboard_last_open);
  }

  return getRelativeDate(user.app_last_open || user.dashboard_last_open);
};

const dates = {
  formatTrialEnd,
  getDaysBetween,
  getRelativeLoginDateForUser,
  getRelativeDate,
};

export default dates;
